import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { SET_COLUMNS, SET_EDITED_ROW, SET_FILTER_VALUE, SET_PAGE, SET_PAGE_SIZE, SET_SORTED } from "./types";
export var reducer = function (state, action) {
  switch (action.type) {
    case SET_FILTER_VALUE:
      var newState = _objectSpread(_objectSpread({}, state), {}, {
        filterValue: action.filterValue
      });
      return action.resetPage && (newState.page = 0), newState;
    case SET_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        page: action.page
      });
    case SET_PAGE_SIZE:
      var _newState = _objectSpread(_objectSpread({}, state), {}, {
        pageSize: action.pageSize
      });
      return action.resetPage && (_newState.page = 0), _newState;
    case SET_SORTED:
      var sorted = action.sorted,
        _newState2 = _objectSpread(_objectSpread({}, state), {}, {
          sorted: null == sorted ? void 0 : _mapInstanceProperty(sorted).call(sorted, function (method) {
            return _objectSpread({}, method);
          })
        });
      return action.resetPage && (_newState2.page = 0), _newState2;
    case SET_COLUMNS:
      return _objectSpread(_objectSpread({}, state), {}, {
        columns: action.columns
      });
    case SET_EDITED_ROW:
      return _objectSpread(_objectSpread({}, state), {}, {
        editedRow: action.rowId
      });
    default:
      return state;
  }
};